export default "__VITE_ASSET__CUXMoXlC__"